import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { CurrentUser } from '../general/modules/user/currentUser';
import { GetConsentResponseType } from './get-consent-response-type';
import { ConsentSources } from '../constants/ConsentSources';

export default class ConsentState {
    public setState(state: boolean, email: string, source: ConsentSources) {
        const currentUser = CurrentUser.getInstance();
        const token = currentUser.getAuthToken();
        const suid = currentUser.getSuid();
        const entryPoint = currentUser.getEntryPoint();
        return HubJsonRpcRequest.makeRequest(HubApiMethods.SET_CONSENT_STATE, {
            consent: state,
            source: source,
            email: email,
            entryPoint: entryPoint,
            suid: suid,
            token: token
        });
    }

    public async getConsentState(): Promise<GetConsentResponseType> {
        const currentUser = CurrentUser.getInstance();
        const token = currentUser.getAuthToken();
        const suid = currentUser.getSuid();
        // @ts-ignore
        const getConsentRequest: GetConsentResponseType = await HubJsonRpcRequest.makeRequest(
            HubApiMethods.GET_CONSENT_STATE,
            {
                token: token,
                suid: suid
            }
        );

        return getConsentRequest;
    }
}
